module.exports = __webpack_public_path__ + "static/img/Round-06-2013.d5b1c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-06-2013.jpg
// module id = Ktp+
// module chunks = 0